import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from "../../src/context/AuthContext";
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const ResetPasswordPage = ({ portalSettings }) => {
    //State Variables
    const [searchParams] = useSearchParams();
    const token = searchParams.get('reset'); // token from URL
    const navigate = useNavigate();
    const { login, isAuthenticated } = useAuth();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Reset Password`;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    //If authenticated - Redirect
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        if (!token) {
            setError('Invalid or missing reset token.');
            return;
        }
        setLoading(true);

        try {
            const payload = {
                newPassword: password,
                token: token
            }
            const res = await fetch(`${apiURL}/account/update-password-with-token`, {
                method: 'POST',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                const data = await res.json().catch(() => ({}));
                setError(data.message || 'Unable to reset password.');
                setLoading(false);
                return;
            }

            setSubmitted(true);
            setLoading(false);

            // Optionally redirect to login after a few seconds
            setTimeout(() => navigate('/login'), 3000);

        } catch (err) {
            console.error('Password reset error:', err);
            setError('An error occurred. Try again later.');
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="auth-container">
                <h2>Password Reset Successful</h2>
                <p>Your password has been updated. Redirecting to login...</p>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <EmptyHeader />
            <EmptyHeader />
            <EmptyHeader />
            
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Reset Password</h2>
                {error && <p className="text-danger">{error}</p>}
                <form  className="baseForm" onSubmit={handleSubmit}>
                    <label className="baseLabel">New Password</label>
                    <input
                        type="password"
                        value={password}
                        className="baseInput"
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <label className="baseLabel">Confirm Password</label>
                    <input
                        type="password"
                        value={confirmPassword}
                        className="baseInput"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <button type="submit" className="baseButton" disabled={loading}>
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
